class AddMemberOrgReq {
    constructor() {
        this.id1 = null;
        this.id2 = null;
    }
}
export default AddMemberOrgReq;